import { DatePipe, JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';

@Component({
  selector: 'app-ais140-api-req-logs',
  templateUrl: './ais140-api-req-logs.component.html',
  styleUrls: ['./ais140-api-req-logs.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatTableModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    JsonPipe,
    DatePipe,
    MatIcon,
    MatTooltip,
    CommonSearchComponent,
    CommonPaginationComponent,
  ],
})
export class AIS140ApiReqLogsComponent implements OnInit {
  listOfBatch = [];
  totalLength = 0;
  size = 10;
  page = 1;
  search = '';
  tmlRequestLogsForm: FormGroup = this.formBuilder.group({});
  userPermission = [];
  apiReqLogsView = false;

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.setAPIReqLogsForm();
    this.checkPermission();
    if (this.apiReqLogsView) {
      this.fetchApiReqLogList();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'AIS140 Ticket TML Request Logs' &&
          element.view === false
        ) {
          this.navigateBack();
        } else if (
          element.pageName === 'AIS140 Ticket TML Request Logs' &&
          element.view === true
        ) {
          this.apiReqLogsView = true;
        }
      }
    );
  }

  setAPIReqLogsForm() {
    this.tmlRequestLogsForm = this.formBuilder.group({
      batchListSearch: new FormControl(''),
    });
  }

  fetchApiReqLogList() {
    this.spinner.show();
    this.listOfBatch = [];
    this.apiMicroservice
      .getApiReqLogsData(this.page, this.size, this.search)
      .subscribe((res) => {
        if (res.status) {
          this.listOfBatch = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar(res.message);
          this.spinner.hide();
        } else {
          this.apiMicroservice.openSnackbar(
            res.message ? res.message : 'Something went wrong'
          );
          this.spinner.hide();
        }
      });
  }

  onPageChange(event: number) {
    this.page = event;
    this.fetchApiReqLogList();
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
    this.fetchApiReqLogList();
  }

  onSearch(event: string) {
    this.page = 1;
    this.search = event;
    this.tmlRequestLogsForm
      ?.get('batchListSearch')
      ?.setValue(this.search ? this.search : '');
    this.fetchApiReqLogList();
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
